import { useTranslation } from 'next-i18next';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import BaseModal, { BaseModalProps } from '../BaseModal';
import ContactSubmitButton, {
  ContactSubmitButtonProps
} from './ContactSubmitButton';

export type ContactModalProps = Pick<BaseModalProps, 'onClose' | 'children'> &
  ContactSubmitButtonProps;

const ContactModal: React.FC<ContactModalProps> = ({
  children,
  onClose,
  onSubmit
}) => {
  const { t } = useTranslation('property');
  const title = t('contact');

  const state = useSelector(
    (state: RootState) => ({
      isMobileModalOpen: state.contactForm.isMobileModalOpen,
      source: state.contactForm.source
    }),
    shallowEqual
  );

  return (
    <BaseModal
      isOpen={state.isMobileModalOpen && state.source === 'contactForm'}
      onClose={onClose}
      footer={<ContactSubmitButton onSubmit={onSubmit} />}
      title={title}
    >
      {children}
    </BaseModal>
  );
};

export default ContactModal;
